import { Feature, FeatureCollection, Point } from "geojson";
import { Map, Marker, Popup } from "maplibre-gl";
import { LayerParams } from "../../map/layer-manager";
import { MapConfig } from "../../models/map-config";
import { MapLayer } from "../map-layer";
import { MarkerBuilder } from "../marker-builder/marker-builder";

/**
 * 
 */
export class MarkerLayer extends MapLayer {

  /** */
  markers: Marker[] = [];

  constructor(private markerBuilder: MarkerBuilder) {
      super();
    }

  hasData(layerParams: LayerParams): boolean {
    let { points } = layerParams;
    return points != null && points.features.length > 0;
  }

  /**
   * Remove os markers do mapa
   * @returns 
   */
  remove(map: Map) {
    
    if (this.markers == null) {
      return;
    }

    for (let marker of this.markers) {
      marker.remove();
    }

    this.markers = [];
  }


  /**
   * Exibe os markers no mapa
   * @param map 
   */
  show(map: Map, layerParams: LayerParams) {

    let markers: Marker[] = [];
    let { points } = layerParams;

    if (points == null || points.features.length == 0) {
      this.markers = [];
      return;
    }

    for (let [index, feature] of points.features.entries()) {

      feature.properties['index'] = index;

      // let color = this.getColor(feature, layerParams);
      // let [ long, lat ] = feature.geometry.coordinates;
      // let marker = this.createMarker(feature, layerParams)
      //   .setLngLat([long, lat]);
      let marker = this.markerBuilder.createMarker(feature, layerParams);

      marker.getElement().addEventListener('click', (ev) => {
        this.markerBuilder.onClicked(feature);
      });

      let popup = this.markerBuilder.createPopupContent(feature, layerParams);
      marker.setPopup(popup);
      marker.addTo(map);

      markers.push(marker);
    }

    this.markers = markers;
    return;
  }

  toggle(map: Map, layerParams: LayerParams): void {
    
  }

}
